import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Col, Row, Spinner, Alert } from '@themesberg/react-bootstrap';
import { ChoosePhotoWidget, ProfileCardWidget } from "../components/Widgets";
import { MyProfileForm } from "../components/AdminEditprofileForm";
import Swal from "sweetalert2";
import api from "../utils/api";
import { Button } from '@themesberg/react-bootstrap';

export default function MyProfile() {
  const { id } = useParams();
  const history = useHistory();
  const [user, setUser] = useState(null);
  const [profilePic, setProfilePic] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    api.get(`/users/${id}`)
      .then(({ data }) => {
        if (data.error) throw new Error(data.message || "Failed to fetch user");
        setUser(data.data);
        setProfilePic(data.data?.profile_pic || null);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [id]);

  const handleProfilePicChange = (file) => {
    console.log("Selected file:", file);
    setProfilePic(file);
  };

  const handleSubmit = async (formData) => {
    console.log("Profile form data submitted:", profilePic);
    setError(null);
    try {
      if (profilePic && profilePic instanceof File) {
        const fd = new FormData();
        Object.entries(formData).forEach(([key, value]) => fd.append(key, value));
        fd.append("profile_pic", profilePic);
        const { data } = await api.put(`/users/${id}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        if (data.error) throw new Error(data.message || "Failed to update user");
        setUser(data.data);
        setProfilePic(data.data.profile_pic || null);
      } else {
        const { data } = await api.put(`/users/${id}`, { ...formData, profile_pic: profilePic });
        if (data.error) throw new Error(data.message || "Failed to update user");
        setUser(data.data);
        setProfilePic(data.data.profile_pic || null);
      }

      Swal.fire({
        title: "Success 🎉",
        text: "Profile updated successfully!",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
        heightAuto: false,
        willClose: () => {
          document.body.style.overflow = "auto";
          document.documentElement.style.overflow = "auto";
        }
      });

    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <Spinner animation="border" />;
  if (error) return <Alert variant="danger">{error}</Alert>;
  if (!user) return null;

  return (
    <Row>
      <Col xs={12} xl={8}>
        <div className="d-flex justify-content-end mb-3">
          <Button variant="outline-primary" size="sm" onClick={() => history.push('/my-reports')}>
            My Reports
          </Button>
        </div>
        <MyProfileForm user={user} onSubmit={handleSubmit} />
      </Col>
      <Col xs={12} xl={4}>
        <Row>
          <Col xs={12}>
            <ProfileCardWidget user={user} profilePic={profilePic} />
          </Col>
          <Col xs={12}>
            <ChoosePhotoWidget
              title="Select profile photo"
              photo={profilePic}
              onPhotoChange={handleProfilePicChange}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
